const doc = [({"en":({"adminLabelActivity":({"facilityName":"Facility name"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;